//src/components/Screene/dxfOku

import { ColorIndex1 } from '../../utils/colorIndex';

var l_typeName = [];
let LTYPES = [];
let TABLES = [];
let KATMANLAR = [];
let Layers = [];
let LTypes = [];
let e, b, d, c;

let renkFlag = false
let LineTypeFlag = false;
let DefaultCizgiK = 40;

var l_typeName = [];
var TextArc
var LayerName, LayerOnOff, layerLock, layerFreeze, LineType, LayerlineTypeName, Color, LayerColor;
var LineScale = 1, LineWeight = 40, EndPointX, EndPointY, EndPointZ, Thickness, X, Y, Z,   ExtrusionDirectionX, ExtrusionDirectionY, ExtrusionDirectionZ
var Color24 = "";

// ✅ PERFORMANCE: Global dizileri temizleme fonksiyonu
// Her yeni DXF parse öncesi çağrılmalı - bellek sızıntısını önler
function resetGlobalArrays() {
	l_typeName.length = 0;
	LTYPES.length = 0;
	TABLES.length = 0;
	KATMANLAR.length = 0;
	Layers.length = 0;
	LTypes.length = 0;
	renkFlag = false;
	LineTypeFlag = false;
	Color24 = "";
}

/**
 * ENTITIES section'daki entity'lerin transparency değerlerini çıkarır
 * @param {string[]} dxfkodu - DXF satırları (trimmed)
 * @returns {Object} handle -> transparency mapping
 */
export function getEntityTransparencyMap(dxfkodu) {
	const transparencyMap = {};

	// ENTITIES section'ı bul
	const entitiesStart = dxfkodu.indexOf('ENTITIES');
	if (entitiesStart === -1) return transparencyMap;

	const entitiesEnd = dxfkodu.indexOf('ENDSEC', entitiesStart);
	if (entitiesEnd === -1) return transparencyMap;

	let currentHandle = null;
	let i = entitiesStart;

	while (i < entitiesEnd) {
		const code = dxfkodu[i];
		const value = dxfkodu[i + 1];

		// Entity handle (grup kodu 5)
		if (code === '5' && value) {
			currentHandle = value.trim().toUpperCase();
		}

		// Transparency (grup kodu 440)
		if (code === '440' && value && currentHandle) {
			const rawValue = parseInt(value);
			// 0x02000000 formatından transparency değerini çıkar (son 8 bit)
			const transparency = rawValue & 0xFF;
			transparencyMap[currentHandle] = transparency;
		}

		i++;
	}

	return transparencyMap;
}

/**
 * DXF dosyasından ATTRIB entity'lerini parse eder ve INSERT handle'larına göre gruplar
 * dxf-parser ATTRIB'leri parse etmediği için manuel olarak çıkarıyoruz
 * @param {string[]} dxfkodu - DXF satırları (trimmed)
 * @returns {Object} insertHandle -> attribs[] mapping
 */
export function getAttribsFromDXF(dxfkodu) {
	const attribsByInsert = {};

	// ENTITIES section'ı bul
	const entitiesStart = dxfkodu.indexOf('ENTITIES');
	if (entitiesStart === -1) return attribsByInsert;

	const entitiesEnd = dxfkodu.indexOf('ENDSEC', entitiesStart);
	if (entitiesEnd === -1) return attribsByInsert;

	let i = entitiesStart;
	let currentInsertHandle = null;

	while (i < entitiesEnd - 1) {
		const code = dxfkodu[i]?.trim();
		const value = dxfkodu[i + 1]?.trim();

		// INSERT entity başlangıcı
		if (code === '0' && value === 'INSERT') {
			// INSERT'in handle'ını bul
			let j = i + 2;
			while (j < entitiesEnd - 1 && dxfkodu[j]?.trim() !== '0') {
				if (dxfkodu[j]?.trim() === '5') {
					currentInsertHandle = dxfkodu[j + 1]?.trim().toUpperCase();
					break;
				}
				j++;
			}
		}

		// ATTRIB entity başlangıcı
		if (code === '0' && value === 'ATTRIB') {
			const attrib = {
				type: 'ATTRIB',
				tag: '',
				text: '',
				position: { x: 0, y: 0, z: 0 },
				textHeight: 2.5,
				rotation: 0,
				layer: '0',
				ownerHandle: null,
				horizontalJustification: 0,
				verticalJustification: 0
			};

			// ATTRIB properties'i parse et - DXF kod-değer çiftleri halinde
			let j = i + 2;
			while (j < entitiesEnd - 1) {
				const attrCode = dxfkodu[j]?.trim();
				const attrValue = dxfkodu[j + 1]?.trim();

				// Yeni entity başlangıcı - çık
				if (attrCode === '0') break;

				switch (attrCode) {
					case '5': // Handle
						attrib.handle = attrValue?.toUpperCase();
						break;
					case '330': // Owner handle (INSERT'in handle'ı)
						attrib.ownerHandle = attrValue?.toUpperCase();
						break;
					case '8': // Layer
						attrib.layer = attrValue;
						break;
					case '10': // Position X
						attrib.position.x = parseFloat(attrValue) || 0;
						break;
					case '20': // Position Y
						attrib.position.y = parseFloat(attrValue) || 0;
						break;
					case '30': // Position Z
						attrib.position.z = parseFloat(attrValue) || 0;
						break;
					case '11': // Alignment point X
						attrib.alignmentPoint = attrib.alignmentPoint || { x: 0, y: 0, z: 0 };
						attrib.alignmentPoint.x = parseFloat(attrValue) || 0;
						break;
					case '21': // Alignment point Y
						attrib.alignmentPoint = attrib.alignmentPoint || { x: 0, y: 0, z: 0 };
						attrib.alignmentPoint.y = parseFloat(attrValue) || 0;
						break;
					case '31': // Alignment point Z
						attrib.alignmentPoint = attrib.alignmentPoint || { x: 0, y: 0, z: 0 };
						attrib.alignmentPoint.z = parseFloat(attrValue) || 0;
						break;
					case '40': // Text height
						attrib.textHeight = parseFloat(attrValue) || 2.5;
						break;
					case '1': // Text value
						attrib.text = attrValue || '';
						break;
					case '2': // Tag
						attrib.tag = attrValue || '';
						break;
					case '7': // Text style
						attrib.textStyle = attrValue;
						break;
					case '50': // Rotation
						attrib.rotation = parseFloat(attrValue) || 0;
						break;
					case '72': // Horizontal justification
						attrib.horizontalJustification = parseInt(attrValue) || 0;
						break;
					case '74': // Vertical justification
						attrib.verticalJustification = parseInt(attrValue) || 0;
						break;
					case '62': // Color
						attrib.color = parseInt(attrValue);
						break;
				}
				j += 2; // ✅ DXF kod-değer çiftleri - 2'şer atla
			}

			// 🔍 Debug: Parse edilen ATTRIB
 

			// ATTRIB'i ilgili INSERT'e ekle
			const ownerHandle = attrib.ownerHandle || currentInsertHandle;
			if (ownerHandle) {
				if (!attribsByInsert[ownerHandle]) {
					attribsByInsert[ownerHandle] = [];
				}
				attribsByInsert[ownerHandle].push(attrib);
			}

			i = j - 1; // Sonraki entity'den devam et
		}

		// SEQEND - INSERT/ATTRIB dizisi sonu
		if (code === '0' && value === 'SEQEND') {
			currentInsertHandle = null;
		}

		i++;
	}

 	return attribsByInsert;
}

export function getHatchFromDXF(dxfkodu) {
	// ✅ PERFORMANCE: Önceki parse'dan kalan verileri temizle
	resetGlobalArrays();

	// DEBUG: 0.1 değeri array'de var mı?
	const idx01 = dxfkodu.findIndex(val => val === "0.1" || val === 0.1);
	const idx10 = dxfkodu.findIndex(val => val === "10.0" || val === 10 || val === "10");
 	// AR-B816 civarındaki değerleri bul
  

	LineType = "ByLayer";
	let HATCH = [];
	let no = dxfkodu.indexOf("TABLES");
	if (no === -1) return { hatch: [] };
	while (no < dxfkodu.length && dxfkodu[no] != "ENDSEC") {
		TABLES.push(dxfkodu[no]);
		no++;
	}
	TABLES.push(dxfkodu[no]);

	//TABLES DİZİSİ İÇİNDE LAYER DİZİSİ Oluşturuluyor
	let k = TABLES.indexOf("LAYER");
	if (k === -1) return { hatch: [] };
	let m = k - 3;
	while (m < TABLES.length && TABLES[m] != "ENDTAB") {
		m++;
		if (m < TABLES.length) Layers.push(TABLES[m]);
	}
	//TABLES DİZİSİ İÇİNDE LTYPE DİZİSİ Oluşturuluyor
	k = TABLES.indexOf("LTYPE");
	if (k === -1) return { hatch: [] };
	m = k - 3;
	while (m < TABLES.length && TABLES[m] != "ENDTAB") {
		m++;
		if (m < TABLES.length) LTypes.push(TABLES[m]);
	}
	no = dxfkodu.indexOf("ENTITIES");
	if (no === -1) return { hatch: [] };

	while (no < dxfkodu.length && dxfkodu[no] != "ENDSEC") {
		HATCH.push(dxfkodu[no]);
		no++;
	}
 	LTypeOku(LTypes);
	LayerOku(Layers);
	const hatch = hacthOku(HATCH)
	return { hatch }
}
 

/**
 * DXF dosyasından layer bilgilerini okur ve object formatında döner
 * dxf-parser'ın eksik bıraktığı locked ve onOff özelliklerini de içerir
 * @param {string[]} dxfkodu - DXF satırları (trimmed)
 * @returns {Object} Layer adı -> layer özellikleri mapping
 */
export function getLayersFromDXF(dxfkodu) {
	const layers = {};

	// TABLES section'ı bul
	let tablesStart = dxfkodu.indexOf("TABLES");
	if (tablesStart === -1) return layers;

	// LAYER table'ı bul
	let layerTableStart = -1;
	for (let i = tablesStart; i < dxfkodu.length; i++) {
		if (dxfkodu[i] === "LAYER" && dxfkodu[i-1] === "2") {
			layerTableStart = i;
			break;
		}
	}
	if (layerTableStart === -1) return layers;

	// ENDTAB'a kadar olan layer section'ı bul
	let layerTableEnd = layerTableStart;
	while (layerTableEnd < dxfkodu.length && dxfkodu[layerTableEnd] !== "ENDTAB") {
		layerTableEnd++;
	}

	// Layer kayıtlarını parse et
	let i = layerTableStart;
	while (i < dxfkodu.length && dxfkodu[i] !== "ENDTAB") {
		if (dxfkodu[i] === "AcDbLayerTableRecord") {
			let layer = {
				name: "",
				onOff: true,
				frozen: false,
				locked: false,
				colorIndex: 7,
				lineType: "Continuous",
				lineWeight: -3,
				transparency: 0
			};

			// AcDbLayerTableRecord'dan sonraki satırdan başla
			let j = i + 1;

			// Bir sonraki layer veya ENDTAB'a kadar kod-değer çiftlerini oku
			while (j < dxfkodu.length - 1) {
				const code = dxfkodu[j].trim();
				const value = dxfkodu[j + 1].trim();

				// Yeni layer veya tablo sonu - çık
				if (code === "0" || code === "AcDbLayerTableRecord" || code === "ENDTAB") {
					break;
				}

				// Kod-değer çiftini işle
				if (code === "2") {
					layer.name = value;
				} else if (code === "62") {
					const colorVal = parseInt(value);
					layer.onOff = colorVal >= 0;
					layer.colorIndex = Math.abs(colorVal);
				} else if (code === "70") {
					const flag = parseInt(value);
					layer.frozen = (flag & 1) !== 0 || (flag & 2) !== 0;
					layer.locked = (flag & 4) !== 0;
				} else if (code === "6") {
					layer.lineType = value;
				} else if (code === "370") {
					layer.lineWeight = parseInt(value) || -3;
				} else if (code === "440") {
					// Eski format (nadiren kullanılır)
					const rawValue = parseInt(value);
					layer.transparency = rawValue & 0xFF;
				} else if (code === "1001" && value === "AcCmTransparency") {
					// ✅ XDATA Transparency: 1001=AcCmTransparency, 1071=değer
					// Bir sonraki satır çiftini kontrol et
					if (j + 2 < dxfkodu.length - 1) {
						const nextCode = dxfkodu[j + 2].trim();
						const nextValue = dxfkodu[j + 3].trim();
						if (nextCode === "1071") {
							const rawValue = parseInt(nextValue);
							// 0x02000000 formatından transparency değerini çıkar (son 8 bit)
							layer.transparency = rawValue & 0xFF;
						}
					}
				}

				j += 2;
			}

			if (layer.name) {
				layers[layer.name] = layer;
			}
			i = j;
		} else {
			i++;
		}
	}

 	return layers;
}

function LTypeOku(Linetip) {
	//for (var a=0 ;a<=tablodizi.length-1;a++){
	let a = 0;
	while (a < Linetip.length && Linetip[a] != "ENDTAB") {
		let l_tipi = [];
		if (Linetip[a] == "AcDbLinetypeTableRecord") {
			//	if (Linetip[a]=="2"){
			l_tipi.push(Linetip[a + 2]);//Ltype Name yazıldı
			l_typeName.push(Linetip[a + 2]);
			//	}
			let v = 0;
			while (a < Linetip.length && Linetip[a] != 73 && Linetip[a] != "ENDTAB") {
				a++;
			}
			if (Linetip[a] == 73) {
				let elemansay = parseInt(Linetip[a + 1]);
				l_tipi.push(elemansay);//Ltype elemansayısı yazıldı	
				if (elemansay != 0) {
					for (var x = a + 4; x <= a + elemansay * 4; x += 4) {
						l_tipi.push(parseInt(Linetip[x + 1]) * LineScale);				//l_tipi.push(parseInt(Linetip[x+5])*LineScale);			
					}
				}
			}
			a++;
			LTYPES.push(l_tipi);
		}
		a++;
	}
}
function LayerOku(tablodizi) {
	//for (var a=0 ;a<=tablodizi.length-1;a++){
	let a = 0;
	while (a < tablodizi.length && tablodizi[a] != "ENDTAB") {
		let Katman = [];
		if (tablodizi[a] == "AcDbLayerTableRecord") {
			let b = a;
			if (tablodizi[b + 1] == 2) {
				Katman.push(tablodizi[b + 2]);//Layer Name yazıldı		
			}
			while (b < tablodizi.length && tablodizi[b] != "ENDTAB" && tablodizi[b] != "347") {
				if (tablodizi[b] == 62) {
					if (tablodizi[b + 1] < 0) {
						Katman.push("off");
						Katman.push(tablodizi[b + 1] * -1);// Color
						LayerColor = (tablodizi[b + 1] * -1);
					} else {
						Katman.push("on");
						Katman.push(tablodizi[b + 1] * 1);// Color
						LayerColor = (tablodizi[b + 1]);
					}
				}
				if (tablodizi[b] == 70) {
					let vv = tablodizi[b + 1] * 1;
					if (vv == 4) {
						Katman.push("NoneFreeze");
						Katman.push("Locked");
					} else if (vv == 1 || vv == 2) {
						Katman.push("Freeze");
						Katman.push("NoneLock");
					} else if (vv == 5) {
						Katman.push("Freeze");
						Katman.push("Locked");
					} else if (vv == 7) {
						Katman.push("Freeze");
						Katman.push("Locked");
					} else if (vv == 0) {
						Katman.push("NoneFreeze");
						Katman.push("NoneLock");
					}
				}
				if (tablodizi[b] == 6) {
					Katman.push(tablodizi[b + 1]);// Color
				}
				if (tablodizi[b] == 370) {
					if (tablodizi[b + 1] == "    -3") {
						Katman.push(DefaultCizgiK);// Color	
					} else {
						Katman.push(tablodizi[b + 1]);// Color	
					}
				}
				b++;
			}
			a = b + 1;
			KATMANLAR.push(Katman);
		}
		a++;
	}
}
function katmanRenk(katmanadı) {
	for (var a = 0; a <= KATMANLAR.length - 1; a++) {

		if (KATMANLAR[a][0] == katmanadı) {

			return KATMANLAR[a][4];
		}
	}
}
function hacthOku(varlikdizi) {
 	var cizim2 = [];
	for (var a = 0; a <= varlikdizi.length - 1; a++) {
		// TEXT (tek SATIR) OKUNMASI------------------------	
		if (varlikdizi[a] == "HATCH") {
			let handle;
			if (varlikdizi[a + 1] === '5') {			//handle
				handle = varlikdizi[a + 2];
			}
			let b = a + 1;
			// Hatch işleme kodları buradalet b = a + 1;
			let HatchPatternName, SolidFillFlag, MPolygon, AssociativityFlag, NumberOfBoundaryPaths, HatchPatternAngle, HatchPatternSpacing, edgeType, IsClosedFlag, NumberOfPolylineVertices, HatchPatternScale
			let pattern = {}
			let boundaryPath = { groups: [] }
			let boundaryPathlar = []

			while (varlikdizi[b] != "AcDbEntity" && b < varlikdizi.length) {
				b++
			}
			// ✅ FIX: Reset globals for each HATCH entity
			renkFlag = false;
			Color24 = "";
			let c = b + 1;
			while (c < varlikdizi.length && varlikdizi[c] != "AcDbHatch") {
				if (varlikdizi[c] === '8') {		//Layer	name
					LayerName = varlikdizi[c + 1];
					LineType = AttributeAl(LayerName, "LayerlineTypeName");
					Color = AttributeAl(LayerName, "lineColor");
					LineWeight = AttributeAl(LayerName, "lineWeight");
					LayerOnOff = AttributeAl(LayerName, "LayerOnOff");
					layerFreeze = AttributeAl(LayerName, "layerFreeze");
					layerLock = AttributeAl(LayerName, "layerLock");
					c++;
				}
				if (varlikdizi[c] === '6') {				//LineType
					LineType = varlikdizi[c + 1];
					c++;
				}
				if (varlikdizi[c] === '62') {
					Color = varlikdizi[c + 1];
					renkFlag = true;
					c++;
				}
				if (varlikdizi[c] === '420') {			//Color
					Color = "";
					Color24 = convertColor24ToHex(varlikdizi[c + 1]);
					renkFlag = true;
					c++;
				}
				if (varlikdizi[c] === '440') {			//
					c++;
				}
				if (varlikdizi[c] === '48') {				//Line Scale
					LineScale = varlikdizi[c + 1];
					c++;
				}

				if (varlikdizi[c] === '370') {			//Line Weight
					LineWeight = varlikdizi[c + 1];
				}
				c++;
				e = c + 2;
			}
			if (renkFlag == false) {
				Color = katmanRenk(LayerName);
				if (typeof (Color) === String) { Color = ColorIndex1(Color.trim()) }
			}
			if (LineTypeFlag == false) {
				LineType = "ByLayer";
			}
			TextArc = 0;
			let hatchFinishFlag = false

			while (hatchFinishFlag != true && e < varlikdizi.length) {
				// ✅ FIX: Strict string comparison (parseInt can match coordinate values like "75.5" → 75)
				if (
					(varlikdizi[e - 1] === '10')
					&& (varlikdizi[e + 1] === '20')
					&& (varlikdizi[e + 3] === '30')
					&& (varlikdizi[e + 5] === '210')
					&& (varlikdizi[e + 7] === '220')
					&& (varlikdizi[e + 9] === '230')
					&& (varlikdizi[e + 11] === '2')
					&& (varlikdizi[e + 13] === '70')
				) {
					X = (1 * varlikdizi[e]);
					Y = (-1 * varlikdizi[e + 2]);
					Z = 0;
					ExtrusionDirectionX = (1 * varlikdizi[e + 6]);
					ExtrusionDirectionY = (1 * varlikdizi[e + 8]);
					ExtrusionDirectionZ = (1 * varlikdizi[e + 10]);
					HatchPatternName = varlikdizi[e + 12];
					SolidFillFlag = parseInt(varlikdizi[e + 14])
 					if (varlikdizi[e + 15] === '63') {
						MPolygon = parseInt(varlikdizi[e + 16]);
					} else if (varlikdizi[e + 15] === '71') {
						MPolygon = null
						AssociativityFlag = parseInt(varlikdizi[e + 16]);
					}
				}

				if (varlikdizi[e] === '91') {
					NumberOfBoundaryPaths = parseInt(varlikdizi[e + 1]);
					let boundaryPathArrayDXF = []
					let BoundaryPathTypeFlagFLAG = false
					let k = e + 2
					while (BoundaryPathTypeFlagFLAG != true && k < varlikdizi.length) {
						boundaryPathArrayDXF.push(varlikdizi[k])
						// ✅ FIX: Strict string comparison to avoid matching coordinate values
						if ((varlikdizi[k + 1] === '75')
							&& (varlikdizi[k + 3] === '76')
						) {
							if ((varlikdizi[k + 5] === '52')
								&& (varlikdizi[k + 7] === '41')
							) {
								HatchPatternAngle = parseInt(varlikdizi[k + 6])
								HatchPatternSpacing = parseInt(varlikdizi[k + 8])
							}
							BoundaryPathTypeFlagFLAG = true
						}
						k++
					}
					const BoundaryPathsS = extractBoundaryPaths(boundaryPathArrayDXF, NumberOfBoundaryPaths)

					BoundaryPathsS.forEach((boundary, b) => {
						boundaryPath = boundaryPathGET(boundary)

						if (boundaryPath !== "none") {
							boundaryPathlar.push(boundaryPath)
						}

					})

					// ✅ FIX: Advance e past extracted boundary data to avoid re-scanning
					e = k;
					continue;
				}
				if (varlikdizi[e] === '41') {				//HatchPatternScale
					HatchPatternScale =  (varlikdizi[e + 1]);
					e++;
				}

				if ((varlikdizi[e] === '77')
					&& (varlikdizi[e + 2] === '78')
				) {

					pattern.lineCount = parseFloat(varlikdizi[e + 3]);
					let patternLine = []

					let patternLineFlag = false
					while (patternLineFlag != true && e < varlikdizi.length) {
						if ((varlikdizi[e] === '53')
							&& (varlikdizi[e + 2] === '43')
							&& (varlikdizi[e + 4] === '44')
							&& (varlikdizi[e + 6] === '45')
							&& (varlikdizi[e + 8] === '46')
							&& (varlikdizi[e + 10] === '79')
						) {
							let line = {}
							line.lineAngle = parseFloat(varlikdizi[e + 1]);
							line.LineBasePointX = parseFloat(varlikdizi[e + 3]);
							line.LineBasePointY = parseFloat(varlikdizi[e + 5]);
							line.LineOffsetX = parseFloat(varlikdizi[e + 7]);
							line.LineOffsetY = parseFloat(varlikdizi[e + 9]);
							let dashCount = parseFloat(varlikdizi[e + 11]);
							line.dashCount = dashCount
							if (dashCount >= 1) {

								let dashes = []
								for (var dc = 0; dc <= dashCount - 1; dc++) {
									if (varlikdizi[e + 12] === '49') {
										dashes.push(parseFloat(varlikdizi[e + 13 + dc * 2]))
									}
								}
								line.dashes = dashes
							}
							patternLine.push(line)
						}
						if ((varlikdizi[e] === '98')
							&& (varlikdizi[e - 2] === '47')
						) {
							patternLineFlag = true
							pattern.patternLine = patternLine
					hatchFinishFlag = true
						}
						e++;
					}

				}
				if (varlikdizi[e] === '98') {
					hatchFinishFlag = true
				}
				/* 			if ((parseInt(varlikdizi[e]) == 0)
								&& (parseInt(varlikdizi[e - 2]) == 1030)
								&& (parseInt(varlikdizi[e - 4]) == 1020)
								&& (parseInt(varlikdizi[e - 6]) == 1010)
								&& (parseInt(varlikdizi[e - 8]) == 1001)
							) {
								hatchFinishFlag = true
							} */
				e++;
			}
			Color = ColorIndex1(Color)
			if ((SolidFillFlag != 0 && HatchPatternName == "SOLID") || HatchPatternName !== "SOLID") {
				let hatch = {
					type: "HATCH", handle, layer: LayerName, color: Color, colorIndex: Color24.trim(), LineScale: LineScale, LineType: LineType, Kalinlik: LineWeight, x: X, y: Y, HatchPatternName, SolidFillFlag, MPolygon, AssociativityFlag, HatchPatternSpacing, HatchPatternAngle, NumberOfBoundaryPaths, boundaryPath: boundaryPathlar, edgeType, IsClosedFlag, NumberOfPolylineVertices, HatchPatternScale, pattern
				}
				cizim2.push(hatch);
			}
		}

	}
	return cizim2;

}


function AttributeAl(katmanAdı, nitelik) {
	let sonuc;
	// Defensive search for the layer entry in KATMANLAR to avoid out-of-bounds access
	if (!Array.isArray(KATMANLAR) || KATMANLAR.length === 0) {
		console.warn('AttributeAl: KATMANLAR is empty or not an array');
		return "";
	}
	let foundIndex = -1;
	for (let i = 0; i < KATMANLAR.length; i++) {
		if (KATMANLAR[i] && KATMANLAR[i][0] === katmanAdı) {
			foundIndex = i;
			break;
		}
	}
	// try a case-insensitive match as a fallback
	if (foundIndex === -1) {
		const needle = String(katmanAdı || "").toLowerCase();
		for (let i = 0; i < KATMANLAR.length; i++) {
			if (KATMANLAR[i] && typeof KATMANLAR[i][0] === 'string' && KATMANLAR[i][0].toLowerCase() === needle) {
				foundIndex = i;
				break;
			}
		}
	}
	if (foundIndex === -1) {
		console.warn(`AttributeAl: layer not found: "${katmanAdı}"`);
		// Return sensible defaults for attributes when layer is missing
		switch (nitelik) {
			case "LayerOnOff":
			case "layerFreeze":
			case "layerLock":
			case "lineWeight":
				return "";
			case "lineColor":
			case "LayerlineTypeName":
				return "";
			default:
				return "";
		}
	}
	let u = foundIndex;
	switch (nitelik) {
		case "LayerOnOff":
			sonuc = KATMANLAR[u][3];
			break;
		case "lineColor":
			sonuc = KATMANLAR[u][4];
			break;
		case "LayerlineTypeName":
			sonuc = KATMANLAR[u][5];
			break;
		case "lineWeight":
			sonuc = KATMANLAR[u][6];
			break;
		case "layerFreeze":
			sonuc = KATMANLAR[u][1];
			break;
		case "layerLock":
			sonuc = KATMANLAR[u][2];
			break;
	}
	return sonuc;
}

/**
 * DXF dosyasından OLE2FRAME entity'lerini parse eder.
 * dxf-parser bu entity tipini desteklemediği için raw text üzerinden çıkarılır.
 * @param {string[]} dxfkodu - DXF satırları (trimmed)
 * @returns {Object[]} OLE2FRAME entity array — her biri {type, handle, layer, upperLeft, lowerRight, binaryHex}
 */
export function getOleFramesFromDXF(dxfkodu) {
	const entities = [];

	const entitiesStart = dxfkodu.indexOf('ENTITIES');
	if (entitiesStart === -1) return entities;

	const entitiesEnd = dxfkodu.indexOf('ENDSEC', entitiesStart);
	if (entitiesEnd === -1) return entities;

	let i = entitiesStart;
	while (i < entitiesEnd - 1) {
		const code  = dxfkodu[i];
		const value = dxfkodu[i + 1];

		if (code === '0' && value === 'OLE2FRAME') {
			const entity = {
				type: 'OLE2FRAME',
				handle: null,
				layer: '0',
				upperLeft:  { x: 0, y: 0, z: 0 },
				lowerRight: { x: 0, y: 0, z: 0 },
				oleVersion: 2,        // group 70 — OLE version (genelde 2)
				itemName:   'OLE',    // group 3 — OLE class adı (örn. "Microsoft Excel Çalışma Sayfası")
				oleType:    2,        // group 71 — 1=link, 2=embedded, 3=static (genelde 2)
				plotQuality: 0,       // group 72
				linkName:   'OLE',    // group 1 — reserved
				hexChunks: [],
			};

			let j = i + 2;
			// 1001 ACAD OLEBEGIN/OLEEND extension data'sından width/height oku.
			// Bazı DXF'lerde standart group 10/11 yerine extension içindeki
			// 1070 41/42 → 1040 <float> ile boyut taşınır.
			let inExt = false;
			let extKey = null;
			let extWidth = null, extHeight = null;
			while (j < entitiesEnd - 1) {
				const c = dxfkodu[j];
				const v = dxfkodu[j + 1];

				if (c === '0') break; // sonraki entity başlangıcı

				if (c === '1001' && v === 'ACAD') { inExt = true; }
				if (inExt) {
					if (c === '1070') extKey = parseInt(v, 10);
					else if (c === '1040' && extKey !== null) {
						if (extKey === 41) extWidth  = parseFloat(v);
						else if (extKey === 42) extHeight = parseFloat(v);
						extKey = null;
					}
				}

				switch (c) {
					case '5':   entity.handle = v?.toUpperCase(); break;
					case '8':   entity.layer  = v; break;
					case '1':   entity.linkName    = v; break;
					case '3':   entity.itemName    = v; break;
					case '70':  entity.oleVersion  = parseInt(v, 10) || 2; break;
					case '71':  entity.oleType     = parseInt(v, 10) || 2; break;
					case '72':  entity.plotQuality = parseInt(v, 10) || 0; break;
					case '10':  entity.upperLeft.x  = parseFloat(v) || 0; break;
					case '20':  entity.upperLeft.y  = parseFloat(v) || 0; break;
					case '30':  entity.upperLeft.z  = parseFloat(v) || 0; break;
					case '11':  entity.lowerRight.x = parseFloat(v) || 0; break;
					case '21':  entity.lowerRight.y = parseFloat(v) || 0; break;
					case '31':  entity.lowerRight.z = parseFloat(v) || 0; break;
					case '310': entity.hexChunks.push(v); break;
				}
				j += 2;
			}

			const hasStdCoords = entity.upperLeft.x !== 0 || entity.upperLeft.y !== 0 ||
				entity.lowerRight.x !== 0 || entity.lowerRight.y !== 0;

			if (entity.hexChunks.length > 0) {
				entity.binaryHex = entity.hexChunks.join('');
				entities.push(entity);
			} else if (hasStdCoords) {
				// Binary yok ama pozisyon biliniyor → placeholder göster
				// (AutoCAD bazı sürümlerde DWG→DXF dönüşümünde OLE binary'sini düşürür).
				console.warn(`[getOleFramesFromDXF] OLE2FRAME ${entity.handle || ''} (${entity.itemName || entity.linkName}) inline binary içermiyor — placeholder gösterilecek.`);
				entity.binaryHex = '';
				entity.noBinary = true;
				entities.push(entity);
			} else {
				// Hem binary hem pozisyon yok → entity'i atla (placeholder yanlış yerde olur).
				console.warn(`[getOleFramesFromDXF] OLE2FRAME ${entity.handle || ''} (${entity.itemName || entity.linkName}) hem binary hem pozisyon içermiyor — atlandı. (ext w=${extWidth} h=${extHeight})`);
			}

			i = j - 1; // i++ ile bir sonraki entity'nin başına geç (getAttribsFromDXF ile aynı pattern)
		}

		i++; // her satırı tara — hizalama sorununu önler
	}

	return entities;
}

function convertColor24ToHex(color24) {
	// Onaltılık değere çevirin
	let hexColor = parseInt(color24).toString(16);

	// 6 haneli bir hex değeri almak için sıfır ekleyin
	while (hexColor.length < 6) {
		hexColor = '0' + hexColor;
	}

	// Renk kodunu # ile birlikte döndürün
	return '#' + hexColor.toUpperCase();
}
function getEdge(dizi) {
	let sonuc = [];
	let geciciDizi = [];

	dizi.forEach((eleman) => {
		if (eleman === '72') {
			if (geciciDizi.length > 0) {
				sonuc.push(geciciDizi);
			}
			geciciDizi = ['72'];
		} else {
			geciciDizi.push(eleman);
		}
	});
	// Son grubu da sonuca ekleyelim
	if (geciciDizi.length > 0) {
		sonuc.push(geciciDizi);
	}
	return sonuc;
}
function boundaryPathGET(boundaryPathArrayDXF) {
	let edgeType
	let boundaryPath = { groups: [] }
	if ((boundaryPathArrayDXF[0]) == 92) {			// 		

		boundaryPath.BoundaryPathTypeFlag = parseInt(boundaryPathArrayDXF[1]);
		if ((boundaryPathArrayDXF[2]) == 93) {
			//boundaryPathArrayDXF.path=boundaryPathArrayDXF.path.slice(4)
			const kenarlar = getEdge(boundaryPathArrayDXF.slice(4));
			kenarlar.forEach((kenar, k) => {
				edgeType = parseInt(kenar[3])
				boundaryPath.groups.push(getBoundary(kenar))
			})
		}
		else if (((boundaryPathArrayDXF[2]) == 72)) {
			edgeType = parseInt(boundaryPathArrayDXF[3])
			//boundaryPathArrayDXF.unshift(edgeType)
			//boundaryPathArrayDXF.unshift(72)			 
			boundaryPath.groups.push(getBoundary(boundaryPathArrayDXF.slice(2)))
		}
	} else {
		console.error("Bad boundary flag", boundaryPathArrayDXF)
		boundaryPath = "none"
	}
	return boundaryPath


}

function getBoundary(kenar) {
	let group = {}
	let knots = []
	let points = []
	let fits = []

	if (kenar[0] != '72' && kenar[0] != 72) {
		console.error("Kenar dizisi 72 kodu ile başlamıyor.", kenar)
		return group
	}

	const edgeType = parseInt(kenar[1])

	// ✅ FIX: step-2 iterasyon ile sadece kod/değer çiftlerini işle
	// Eski forEach döngüsü değerleri (ör. 93 grubunun '10' değeri) kod olarak eşleştiriyordu
	switch (edgeType) {
		case 0: { // Polyline (72=0, HasBulge=false)
			group.edgeType = "Polyline"
			for (let k = 0; k < kenar.length - 1; k += 2) {
				const code = kenar[k]
				const value = kenar[k + 1]
				if (code === '73') group.IsClosedFlag = parseInt(value)
				else if (code === '93') group.NumberOfPolylineVertices = parseInt(value)
				else if (code === '10') points.push(parseFloat(value))
				else if (code === '20') points.push(parseFloat(value))
				else if (code === '42') { points.push(parseFloat(value)); group.bulge = true }
			}
			group.points = points
			break
		}
		case 1: { // Line / Polyline-with-bulge (72=1)
			group.edgeType = "Line"
			// Pre-scan: '42' kod pozisyonunda (çift index) var mı?
			let hasBulge = false
			for (let k = 0; k < kenar.length - 1; k += 2) {
				if (kenar[k] === '42') { hasBulge = true; break }
			}

			if (hasBulge) {
				// Polyline with bulge: [72,1, 73,closed, 93,numVerts, 10,X, 20,Y, 42,B, ...]
				for (let k = 0; k < kenar.length - 1; k += 2) {
					const code = kenar[k]
					const value = kenar[k + 1]
					if (code === '73') group.IsClosedFlag = parseInt(value)
					else if (code === '93') group.NumberOfPolylineVertices = parseInt(value)
					else if (code === '10') points.push(parseFloat(value))
					else if (code === '20') points.push(parseFloat(value))
					else if (code === '42') { points.push(parseFloat(value)); group.bulge = true }
				}
				group.points = points
			} else {
				// Edge line: [72,1, 10,X1, 20,Y1, 11,X2, 21,Y2]
				for (let k = 0; k < kenar.length - 1; k += 2) {
					const code = kenar[k]
					const value = kenar[k + 1]
					if (code === '10') group.x1 = parseFloat(value)
					else if (code === '20') group.y1 = parseFloat(value)
					else if (code === '11') group.x2 = parseFloat(value)
					else if (code === '21') group.y2 = parseFloat(value)
				}
			}
			break
		}
		case 2: { // CircularArc
			group.edgeType = "CircularArc"
			for (let k = 0; k < kenar.length - 1; k += 2) {
				const code = kenar[k]
				const value = kenar[k + 1]
				if (code === '10') group.x = parseFloat(value)
				else if (code === '20') group.y = parseFloat(value)
				else if (code === '40') group.radius = parseFloat(value)
				else if (code === '50') group.StartAngle = parseFloat(value)
				else if (code === '51') group.EndAngle = parseFloat(value)
				else if (code === '73') group.IsCounterclockwiseFlag = parseFloat(value)
			}
			break
		}
		case 3: { // EllipticArc
			group.edgeType = "EllipticArc"
			for (let k = 0; k < kenar.length - 1; k += 2) {
				const code = kenar[k]
				const value = kenar[k + 1]
				if (code === '10') group.x = parseFloat(value)
				else if (code === '20') group.y = parseFloat(value)
				else if (code === '11') group.EndPointX = parseFloat(value)
				else if (code === '21') group.EndPointY = parseFloat(value)
				else if (code === '40') group.ratioOfMinor = parseFloat(value)
				else if (code === '50') group.StartAngle = parseFloat(value)
				else if (code === '51') group.EndAngle = parseFloat(value)
				else if (code === '73') group.IsCounterclockwiseFlag = parseFloat(value)
			}
			break
		}
		case 4: { // Spline
			group.edgeType = "Spline"
			for (let k = 0; k < kenar.length - 1; k += 2) {
				const code = kenar[k]
				const value = kenar[k + 1]
				if (code === '94') group.Degree = parseFloat(value)
				else if (code === '73') group.rational = parseFloat(value)
				else if (code === '74') group.preiodic = parseFloat(value)
				else if (code === '95') group.numberOfKnots = parseFloat(value)
				else if (code === '96') group.numberOfControlPoints = parseFloat(value)
				else if (code === '40') knots.push(parseFloat(value))
				else if (code === '10') {
					points.push(parseFloat(value))
					if (kenar[k + 2] === '20') points.push(parseFloat(kenar[k + 3]))
				}
				else if (code === '11') {
					fits.push(parseFloat(value))
					if (kenar[k + 2] === '21') fits.push(parseFloat(kenar[k + 3]))
				}
			}
			group.knots = knots
			group.points = points
			group.fits = fits
			break
		}
	}

	return group
}

function extractBoundaryPaths(varlikdizi, NumberOfBoundaryPaths) {
	let boundaryPaths = [];
	if (NumberOfBoundaryPaths === 1) {
		boundaryPaths = [varlikdizi]
	} else {
		let count = NumberOfBoundaryPaths
		let c1 = 0
		while (count != 0) {
			let currentBoundaryPath = [];
			while (c1 < varlikdizi.length && varlikdizi[c1] !== '97') {
				currentBoundaryPath.push(varlikdizi[c1])
				c1++
			}
			const referenceCount = parseInt(varlikdizi[c1 + 1]);
			c1 += 2 + (2 * referenceCount);
			boundaryPaths.push(currentBoundaryPath)
			currentBoundaryPath = []
			count--
		}
	}
	return boundaryPaths;
}
